"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Fab_1 = __importDefault(require("@mui/material/Fab"));
var material_1 = require("@mui/material");
/** Basic MUI loading button but with our specific styling */
exports.Component = (0, material_1.styled)(Fab_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        textTransform: 'none',
        '&.MuiFab-primary': {
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
        '&.MuiFab-secondary': {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.secondary.main,
            '&:hover': {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.background.default,
            },
            '@media (hover: none)': {
                '&:hover': {
                    color: theme.palette.secondary.main,
                    backgroundColor: theme.palette.background.default,
                },
            },
        },
    });
});
